import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-12 items-center pt-8 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Fecha de envio* ", -1)
const _hoisted_3 = { class: "col-span-2 flex flex-row gap-4 items-center" }
const _hoisted_4 = { class: "relative flex flex-row items-center gap-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-4 h-full items-start pt-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Descripción")
], -1)
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "flex flex-row justify-center items-center gap-4 w-full" }
const _hoisted_8 = ["disabled"]

import { ref, watch, computed } from "vue";

import { storeToRefs } from "pinia";

import useInvestmentContractAlertsStore from "@/stores/investment-contract-alerts";

import NewModal from "@/components/atoms/NewModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditAlertModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
  contractId: {
    type: Number,
    required: true,
  },
  alertId: {
    type: Number,
    required: true,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;





const alertStore = useInvestmentContractAlertsStore();

const isOpen = computed(() => props.visible);
const alertId = computed(() => props.alertId);
const contractId = computed(() => props.contractId);

const { updateForm, createResponse } = storeToRefs(alertStore);

const updateIsPending = ref<boolean>(false);

const formIsValid = computed(
  () => updateForm.value.shipmentDate && updateForm.value.description
);

const handleUpdateAlert = async () => {
  emit("update:visible");
  await alertStore.updateAlert(alertId.value, contractId.value);
  alertStore.clearUpdateForm();
};

watch(isOpen, () => {
  if (isOpen.value) alertStore.fetchAlert(alertId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createBlock(NewModal, {
    title: "Editar alerta de contrato",
    visible: isOpen.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = () => _ctx.$emit('update:visible'))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleUpdateAlert())),
          disabled: !formIsValid.value,
          class: "flex flex-row items-center rounded-full px-4 py-2 bg-green-700 text-sm shadow text-white disabled:bg-gray-500 transition-all"
        }, " Enviar ", 8, _hoisted_8)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Datepicker, {
              modelValue: _unref(updateForm).shipmentDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(updateForm).shipmentDate) = $event)),
              "teleport-center": "",
              "input-class-name": "newcalssinput",
              "enable-time-picker": false,
              format: "dd/MM/yyyy",
              cancelText: 'Cancelar',
              selectText: 'Seleccionar',
              "min-date": new Date()
            }, null, 8, ["modelValue", "min-date"])
          ])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("textarea", {
            class: "border w-full border-gray-300 rounded-md p-2 text-sm",
            maxlength: "1000",
            placeholder: "Agregue un comentario...",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(updateForm).description) = $event))
          }, null, 512), [
            [_vModelText, _unref(updateForm).description]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})